var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsUUID, ValidateNested } from 'class-validator';
import { AiDraftPayloadDto } from './ai-draft-payload.dto.js';
/**
 * Body of `POST /ai-documentation/drafts/:draftId/save` (Spec § 9): the draft
 * as the author edited it in the review, content fields only. The server
 * re-validates it against Schema v2 and `checkDraft` before rendering
 * (Spec § 3.5), so this only guarantees the shape.
 */
export class SaveAiDraftDto {
    payload;
}
__decorate([
    Expose(),
    IsDefined(),
    ValidateNested(),
    Type(() => AiDraftPayloadDto),
    __metadata("design:type", AiDraftPayloadDto)
], SaveAiDraftDto.prototype, "payload", void 0);
/** `201 { itemId }` — the new `AI_ASSISTED` documentation item. */
export class SaveAiDraftResponseDto {
    itemId;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], SaveAiDraftResponseDto.prototype, "itemId", void 0);
//# sourceMappingURL=save-ai-draft.dto.js.map